import { fetchKurlyMallConfig } from '../api/kurly-mall-config/kurlyMallConfig';
import { KurlyMallConfig } from '../interfaces/KurlyMallConfig';

export const getKurlyMallConfig = (): Promise<KurlyMallConfig> => {
  return fetchKurlyMallConfig();
};
